export default __webpack_public_path__ + "static/media/029-turn left.ebfb7602.png";